'use client'

import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import { Thumbs } from 'swiper/modules';
import { NumericFormat } from "react-number-format";
import { FallBackImage } from "../commons/fallback-image";
import { useRef, useState } from "react";
import Lightbox from "yet-another-react-lightbox";
import Fullscreen from "yet-another-react-lightbox/plugins/fullscreen";
import Thumbnails from "yet-another-react-lightbox/plugins/thumbnails";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import "yet-another-react-lightbox/styles.css";
import "yet-another-react-lightbox/plugins/thumbnails.css";
import { useForm } from 'react-hook-form';
import { useReCaptcha } from 'next-recaptcha-v3';
import InputMask from 'react-input-mask';
import { fetchPostEmailSendPurpose } from '@/services/api';

export default function CarDetails({ ad, adsLastOffers, company }) {
    const [index, setIndex] = useState(-1);
    const [openYoutubeVideo, setOpenYoutubeVideo] = useState(false);
    const [formPost, setFormPost] = useState({ isLoading: false, isError: false, errorText: '', isSuccess: false });
    const [thumbsSwiper, setThumbsSwiper] = useState(null);
    const { register, handleSubmit, formState: { errors }, setValue } = useForm();
    const { executeRecaptcha } = useReCaptcha();

    const adLink = `anuncio/${ad.category}/${`${ad.brand.split(' ').join('-').toLowerCase()}-${ad.model.split(' ').join('-').toLowerCase()}`}/${ad.yearModel}/${ad.id}`;
    const message = `Olá, gostaria de informações sobre ${ad.brand} ${ad.model} - Link do Veículo: ${adLink}`;
    const adWhatsapp = `https://api.whatsapp.com/send?phone=55${company.whatsapp}&text=${company.whatsappDetailsMessage ? company.whatsappDetailsMessage : message}`;
    const swiperRef = useRef();

    const onSubmit = async data => {
        const token = await executeRecaptcha("proposalSubmit");
        setFormPost({ ...formPost, isLoading: true, isError: false, errorText: '', isSuccess: false });
        fetchPostEmailSendPurpose({
            cellPhone: data.txtCellPhone,
            email: data.txtEmail,
            message: data.txtMessage,
            name: data.txtName,
            idAd: ad.id,
            token
        })
            .then(res => {
                if (res) {
                    setValue('txtName', '');
                    setValue('txtEmail', '');
                    setValue('txtCellPhone', '');
                    setValue('txtMessage', '');
                    setFormPost({ ...formPost, isLoading: false, isSuccess: true });
                }
            })
            .catch(err => { setFormPost({ ...formPost, isLoading: false, isError: true, errorText: err.toString() }); });
    }

    return (
        <section className="content-sm">
            <div className="auto-container">
                <div className="row">
                    <div className="col-12 col-sm-12 col-md-12 col-lg-7 col-xl-7 theme-mb-20">
                        <div id="product-detail" className="single-box">
                            <div className="row">
                                <div className="col-md-12 img-box-client">
                                    <Swiper
                                        className='swiperProducts'
                                        modules={[Navigation, Thumbs]}
                                        spaceBetween={10}
                                        autoHeight={false}
                                        effect='fade'
                                        loop={true}
                                        navigation={true}
                                        wrapperClass='swiper-wrapper item-big'
                                        thumbs={{ swiper: thumbsSwiper }}
                                    >
                                        {
                                            ad.photos.map((photo, index) =>
                                                <SwiperSlide className="swiper-slide itembig imgbg" style={{ backgroundImage: `url("${photo}")` }} key={index}>
                                                    {
                                                        ad.videos.length > 0
                                                            ? <div className="link-image-large-left">
                                                                <button
                                                                    className="img-hover"
                                                                    title={`Vídeo do veículo ${ad.model.toLowerCase()} ${ad.version ? ad.version.toLowerCase().replace(ad.model.toLowerCase(), '') : ''}`}
                                                                    onClick={() => setOpenYoutubeVideo(true)}
                                                                >
                                                                    <i className="mdi mdi-youtube"></i> VÍDEO DO VEÍCULO
                                                                </button>
                                                            </div>
                                                            : null
                                                    }
                                                    <div className="link-image-large">
                                                        <button
                                                            className="img-hover"
                                                            title={`Ampliar foto ${ad.model.toLowerCase()} ${ad.version ? ad.version.toLowerCase().replace(ad.model.toLowerCase(), '') : ''}`}
                                                            onClick={() => setIndex(index)}
                                                        >
                                                            <i className="mdi mdi-magnify-plus-outline"></i> AMPLIAR IMAGEM
                                                        </button>
                                                    </div>
                                                </SwiperSlide>
                                            )
                                        }
                                        {
                                            ad.photos.length === 0 ?
                                                <SwiperSlide className="swiper-slide itembig imgbg" style={{ backgroundImage: `url("/images/no-image.jpeg")` }} key={0}>
                                                </SwiperSlide>
                                                : null

                                        }
                                    </Swiper>
                                    <Swiper
                                        className='thumbProducts'
                                        modules={[Thumbs]}
                                        loop
                                        spaceBetween={20}
                                        slidesPerView={4}
                                        freeMode
                                        watchSlidesProgress
                                        onSwiper={setThumbsSwiper}
                                    >
                                        {
                                            ad.photos.map((photo, index) =>
                                                <SwiperSlide className="swiper-slide imgbg" style={{ backgroundImage: `url("${photo}")` }} key={index} />
                                            )
                                        }
                                        {
                                            ad.photos.length === 0 ?
                                                <SwiperSlide className="swiper-slide imgbg" style={{ backgroundImage: `url("/images/no-image.jpeg")` }} key={0} />
                                                : null

                                        }
                                    </Swiper>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-sm-12 col-md-12 col-lg-5 col-xl-5">
                        <div className="site-heading text-left">
                            <h3 style={{ textTransform: 'capitalize' }}>{`${ad.model.toLowerCase()} ${ad.version ? ad.version.toLowerCase().replace(ad.model.toLowerCase(), '') : ''}`}</h3>
                            <p></p>
                        </div>
                        <div className="theme-mb-20 clearfix"></div>
                        <div className="w-100 d-block clearfix princing_top">
                            <h3>
                                <strong>
                                    {ad.promotionalPrice ?
                                        <div className='d-flex justify-content-between align-items-center'>
                                            <div>
                                                <NumericFormat
                                                    value={ad.price ? ad.price : 0}
                                                    displayType={'text'}
                                                    thousandSeparator="."
                                                    decimalSeparator=","
                                                    decimalScale={2}
                                                    fixedDecimalScale={true}
                                                    prefix={'De R$ '} />
                                                <br />
                                                <NumericFormat
                                                    value={ad.promotionalPrice ? ad.promotionalPrice : 0}
                                                    displayType={'text'}
                                                    thousandSeparator="."
                                                    decimalSeparator=","
                                                    decimalScale={2}
                                                    fixedDecimalScale={true}
                                                    prefix={'Por R$ '} />
                                            </div>
                                            <div>
                                                <div className='d-flex align-items-center'>
                                                    <i style={{ color: "green", fontSize: "35px" }} className='mdi mdi-arrow-down-thick'></i>
                                                    <p style={{ color: "green", fontSize: "25px" }} className='mb-0'>{(((ad.price - ad.promotionalPrice) / ad.price) * 100).toFixed(1).replace('.', ',')}%</p>
                                                </div>
                                                <h6 style={{ color: "green" }}>DE DESCONTO</h6>
                                            </div>
                                        </div>
                                        :


                                        ad.price
                                            ? <NumericFormat
                                                value={ad.price ? ad.price : 0}
                                                displayType={'text'}
                                                thousandSeparator="."
                                                decimalSeparator=","
                                                decimalScale={2}
                                                fixedDecimalScale={true}
                                                prefix={'R$ '} />
                                            : 'consulte-nos'

                                    }
                                </strong>
                            </h3>
                        </div>
                        <div className="clearfix w-100 d-block "></div>
                        <div className="theme-mb-20 clearfix"></div>
                        <ul className="list-unstyled description-car theme-mb-10">
                            <li>
                                <div className='icon'>
                                    <i className="mdi mdi-calendar"></i>
                                </div>
                                <div>
                                    <p className='mb-0'>Ano</p>
                                    {`${ad.yearFabrication} - ${ad.yearModel}`}
                                </div>
                            </li>
                            <li>
                                <div className='icon'>
                                    <i className="mdi mdi-counter"></i>
                                </div>
                                <div>
                                    <p className='mb-0'>Quilometragem</p>
                                    {
                                        ad.mileage
                                            ? <NumericFormat
                                                value={ad.mileage}
                                                displayType={'text'}
                                                thousandSeparator="."
                                                decimalSeparator=","
                                                decimalScale={0}
                                                fixedDecimalScale={true}
                                                suffix=' km' />
                                            : ' - km'
                                    }
                                </div>
                            </li>
                            <li>
                                <div className='icon'>
                                    <i className="mdi mdi-format-color-fill"></i>
                                </div>
                                <div>
                                    <p className='mb-0'>Cor</p>
                                    {ad.color}
                                </div>
                            </li>
                            <li>
                                <div className='icon'>
                                    <i className="mdi mdi-gas-station"></i>
                                </div>
                                <div>
                                    <p className='mb-0'>Combustível</p>
                                    {ad.fuel}
                                </div>
                            </li>
                            <li>
                                <div className='icon'>
                                    <i className="mdi mdi-car-shift-pattern"></i>
                                </div>                                <div>
                                    <p className='mb-0'>Transmissão</p>
                                    {ad.transmission}
                                </div>
                            </li>
                            <li>
                                <div className='icon'>
                                    <i className="mdi mdi-car-door"></i>
                                </div>
                                <div>
                                    <p className='mb-0'>Portas</p>
                                    {`${ad.doors} portas`}
                                </div>
                            </li>
                        </ul>
                        <div className="theme-mb-20 clearfix"></div>
                        <a
                            href={adWhatsapp}
                            rel="nofollow"
                            target="_blank"
                            title="Entre em contato conosco através de nosso whatsapp"
                            className="btn btn-whatsapp btn-icon btn-block theme-mb-30"
                        >
                            <i className="mdi mdi-whatsapp"></i>
                            <div>
                                <span> Entre em contato </span>
                                <p className='mb-0'> Fale com um especialista </p>
                            </div>
                        </a>
                    </div>
                </div>
                <div className="clearfix"></div>
                <div className="row">
                    {
                        ad.optionals && ad.optionals.length > 0
                            ? <div className="col-md-12 theme-mt-20 theme-mb-10">
                                <div className="site-heading text-left">
                                    <h2>Opcionais:</h2>
                                    <p></p>
                                </div>
                                <div className="clearfix w-100 d-block theme-pb-10"></div>
                                <ul className="list-item">
                                    {ad.optionals.map((item, index) => <li key={index}><span className="me-2"><i className="mdi mdi-check"></i></span>{item}</li>)}
                                </ul>
                            </div>
                            : null
                    }
                    <div className="col-md-12 theme-mt-20 theme-mb-10">
                        <div className="site-heading text-left">
                            <h2>Observações:</h2>
                            <p></p>
                        </div>
                        <div className="clearfix w-100 d-block theme-pb-10"></div>
                        <span className="me-2">{ad.description ? ad.description : '---'}</span>
                    </div>
                </div>
                <div className="clearfix w-100 d-block theme-pb-20"></div>
                <div className="row">
                    <div className="col-md-12">
                        <div className="site-heading text-left">
                            <h2>Envie uma mensagem!</h2>
                            <p></p>
                        </div>
                        <div className="clearfix w-100 d-block"></div>
                    </div>
                    <div className="col-md-12 theme-mb-30">
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <div className="row">
                                <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                    <div className="form-group">
                                        <label>Nome: <span>*</span></label>
                                        <input type="text" className="form-control" placeholder="Nome Completo" {...register("txtName", { required: true })} required={errors.txtName} />
                                    </div>
                                </div>
                                <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                    <div className="form-group">
                                        <label>Email: <span>*</span></label>
                                        <input type="email" className="form-control" placeholder="Email" {...register("txtEmail", { required: true, pattern: /^\S+@\S+$/i })} required={errors.txtEmail} />
                                    </div>
                                </div>
                                <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                    <div className="form-group">
                                        <label>Telefone: <span>*</span></label>
                                        <InputMask type={'tel'} className="form-control" mask="(99) 99999-9999" maskChar=" " placeholder="Celular" {...register("txtCellPhone", { required: true })} required={errors.txtCellPhone} />
                                    </div>
                                </div>
                                <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                    <div className="form-group">
                                        <label>Mensagem: <span>*</span></label>
                                        <textarea
                                            className="form-control"
                                            placeholder="Mensagem"
                                            rows="5"
                                            {...register("txtMessage", { required: true })}
                                            required={errors.txtMessage}>
                                            {`Olá gostaria de mais informações sobre o veículo ${ad.brand} ${ad.model} ${ad.version ? ad.version.toLowerCase().replace(ad.model.toLowerCase(), '') : ''} - ${ad.yearModel}`}
                                        </textarea>
                                    </div>
                                </div>
                                {
                                    formPost.isError
                                        ? <div className="col-md-12">
                                            <div class="alert alert-danger" role="alert">{formPost.errorText}</div>
                                        </div>
                                        : null
                                }
                                {
                                    formPost.isSuccess
                                        ? <div className="col-md-12">
                                            <div class="alert alert-success" role="alert">Contato enviado com sucesso, aguarde o retorno de nossa equipe!</div>
                                        </div>
                                        : null
                                }
                                <div className="col-md-12 mt-3">
                                    <button type="submit" disabled={formPost.isLoading} name="SendFormContato" value="SendFormContato" className="btn btn-lblue btn-arrow">
                                        <span> ENVIAR MENSAGEM<i className="mdi mdi-send"></i></span>
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
                <div className="clearfix w-100 d-block theme-pb-20"></div>
                {
                    adsLastOffers && adsLastOffers.items && adsLastOffers.items.length > 0
                        ? <div className="auto-container">
                            <div className="row">
                                <div className="col-md-12 theme-mb-20">
                                    <div className="site-heading text-left">
                                        <h2>Você pode se interessar por:</h2>
                                        <p></p>
                                    </div>
                                </div>
                            </div>
                            <div className="clearfix"></div>
                            <div className="row">
                                <div className="col-md-12">
                                    <Swiper
                                        id='listCars'
                                        modules={[Navigation]}
                                        spaceBetween={25}
                                        slidesPerView={1}
                                        centeredSlides={true}
                                        loop={true}
                                        navigation={true}
                                        breakpoints={{
                                            320: {
                                                slidesPerView: 1,
                                                spaceBetween: 30,
                                            },
                                            640: {
                                                slidesPerView: 2,
                                                spaceBetween: 30,
                                            },
                                            1024: {
                                                slidesPerView: 3,
                                                spaceBetween: 25,
                                            },
                                            1250: {
                                                slidesPerView: 4.1,
                                                spaceBetween: 25,
                                                centeredSlides: true
                                            }
                                        }}
                                        onSwiper={(swiper) => { swiperRef.current = swiper; }}
                                    >
                                        <div className="swiper-wrapper">
                                            {
                                                adsLastOffers.items.map((item, index) => {
                                                    const adLink = `/anuncio/${item.category}/${`${item.brand.split(' ').join('-').toLowerCase()}-${item.model.split(' ').join('-').toLowerCase()}`}/${item.yearModel}/${item.id}`;
                                                    const adTitle = `Compre agora mesmo ${item.brand} ${item.model}`;
                                                    const adWhatsapp = `https://api.whatsapp.com/send?phone=55${company.whatsapp}&text=${company.whatsappDetailsMessage ? company.whatsappDetailsMessage : message}`;

                                                    return <SwiperSlide className='theme-mb-30' key={index}>
                                                        <div className="filter-card-item position-relative overflow-hidden rounded bg-white">
                                                            <a href={adLink} title={adTitle} className="icon-btn compare-btn position-absolute">
                                                                <i className="mdi mdi-plus"></i>
                                                            </a>
                                                            <a href={adWhatsapp} title={adTitle} target="_blank" className="icon-btn wish-btn position-absolute">
                                                                <i className="mdi mdi-whatsapp"></i>
                                                            </a>
                                                            <span className="date position-absolute">{`${item.yearFabrication} - ${item.yearModel}`}</span>
                                                            <div className="feature-thumb position-relative overflow-hidden" style={{ height: '220px' }}>
                                                                <a href={adLink} title={adTitle}>
                                                                    <FallBackImage
                                                                        className='img-fluid'
                                                                        style={{
                                                                            width: '100%',
                                                                            objectFit: 'cover',
                                                                            position: 'absolute'
                                                                        }}
                                                                        alt={adTitle}
                                                                        title={adTitle}
                                                                        src={item.mainPhoto ? item.mainPhoto : "/images/no-image.jpeg"} />
                                                                </a>
                                                            </div>
                                                            <div className="filter-card-content">
                                                                <div className="price-btn text-start position-relative">
                                                                    {item.promotionalPrice ?
                                                                        <div>
                                                                            <NumericFormat
                                                                                className="small-btn-meta"
                                                                                style={{ fontSize: '14px' }}
                                                                                value={item.price ? item.price : null}
                                                                                displayType={'text'}
                                                                                thousandSeparator="."
                                                                                decimalSeparator=","
                                                                                decimalScale={2}
                                                                                fixedDecimalScale={true}
                                                                                prefix={'De R$ '} />
                                                                            <br />
                                                                            <NumericFormat
                                                                                className="small-btn-meta"
                                                                                style={{ fontSize: '14px' }}
                                                                                value={item.promotionalPrice ? item.promotionalPrice : null}
                                                                                displayType={'text'}
                                                                                thousandSeparator="."
                                                                                decimalSeparator=","
                                                                                decimalScale={2}
                                                                                fixedDecimalScale={true}
                                                                                prefix={'Por R$ '} />
                                                                        </div>
                                                                        :
                                                                        <span className="small-btn-meta">
                                                                            {
                                                                                item.price ?
                                                                                    <NumericFormat
                                                                                        className="small-btn-meta"
                                                                                        style={{ fontSize: '14px' }}
                                                                                        value={item.price ? item.price : null}
                                                                                        displayType={'text'}
                                                                                        thousandSeparator="."
                                                                                        decimalSeparator=","
                                                                                        decimalScale={2}
                                                                                        fixedDecimalScale={true}
                                                                                        prefix={'R$ '} />
                                                                                    : 'consulte-nos'
                                                                            }
                                                                        </span>}
                                                                </div>
                                                                <span className="meta-content mt-2 d-block"><strong>{item.brand}</strong></span>
                                                                <a href={adLink} title={adTitle} className="mt-1 d-block">
                                                                    <h5
                                                                        style={{
                                                                            textOverflow: 'ellipsis',
                                                                            overflow: 'hidden',
                                                                            display: 'inline-block',
                                                                            width: '100%'
                                                                        }}>{item.version}</h5>
                                                                </a>
                                                                <div className="clearfix d-block w-100 theme-pt-10"></div>
                                                                <ul>
                                                                    <li>
                                                                        <i className="mdi mdi-speedometer"></i>
                                                                        {
                                                                            item.mileage ?
                                                                                <NumericFormat
                                                                                    value={item.mileage}
                                                                                    displayType={'text'}
                                                                                    thousandSeparator="."
                                                                                    decimalSeparator=","
                                                                                    decimalScale={0}
                                                                                    fixedDecimalScale={true}
                                                                                    suffix=' km' />
                                                                                : ' - km'
                                                                        }
                                                                    </li>
                                                                    <li><i className="mdi mdi-car-shift-pattern"></i>{item.transmission}</li>
                                                                    <li><i className="mdi mdi-gas-station"></i>{item.fuel}</li>
                                                                    <li><i className="mdi mdi-car-door"></i>{item.doors ? `${item.doors} Portas` : 'n/i'}</li>
                                                                </ul>
                                                                <a href={adLink} title={adTitle} className="btn outline-btn btn-sm d-block">VER MAIS DETALHES</a>
                                                            </div>
                                                        </div>
                                                    </SwiperSlide>
                                                }
                                                )
                                            }
                                        </div>
                                        <div className="swiper-button-prev" onClick={() => { swiperRef.current.slidePrev(); }}>
                                            <img src="../../../../../fonts/arrow-left.svg" alt="Próximo Slider" />
                                        </div>
                                        <div className="swiper-button-next" onClick={() => { swiperRef.current.slideNext(); }}>
                                            <img src="../../../../../fonts/arrow-right.svg" alt="Slider Anterior" />
                                        </div>
                                    </Swiper>
                                </div>
                            </div>
                        </div>
                        : null
                }
                <div className="clearfix"></div>
            </div>

            <Lightbox
                open={index >= 0}
                index={index}
                close={() => setIndex(-1)}
                slides={ad.photos.map(item => ({ src: item }))}
                plugins={[Fullscreen, Thumbnails, Zoom]}
                styles={{ root: { zIndex: 99999 } }}
            />
            <Lightbox
                open={openYoutubeVideo}
                close={() => setOpenYoutubeVideo(false)}
                slides={[{ type: "youtube", src: ad.videos[0] }]}
                render={{
                    slide: ({ type, src }) =>
                        type === "youtube" ? (
                            <iframe
                                style={{ width: '100%', height: '100%' }}
                                src={src}
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                allowFullScreen
                            ></iframe>
                        ) : null
                }}
            />

        </section>
    )
}